import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const CallForHelpPage = lazy(() => import("./pages/CallForHelpPage"));

const withCallForHelpProvider = (element) => (
  <FeatureProvider namespace={Feature_NAMESPACES.CALL_FOR_HELP}>
    {element}
  </FeatureProvider>
);

export const callForHelpRoutes = [
  {
    path: PATHS.CALL_FOR_HELP,
    element: withCallForHelpProvider(<CallForHelpPage />),
  },
];
